/**
 *
 * Asynchronously loads the component for Mse002
 * Author: LanVt
 */

import loadable from 'utils/loadable';

export default loadable(() => import('./index'));
